export const getName = (userName) => {
  let name = userName?.split(" ");
  if (name?.length < 2) return name[0][0].toUpperCase();
  else if (name?.length >= 2)
    return name[0][0].toUpperCase() + name[1][0].toUpperCase();
};

export const dateFormat = (value) => {
  let d = value?.split("-") || []
  if (d[1] && d[2] && d[0])
    return ((d[2] + "-" + d[1] + "-" + d[0]))
  else return ""
}

export const checkDobUnit=(date)=>{
  const inputDate = new Date(date);
  const currentDate = new Date();

  const diffInTime = currentDate - inputDate;
  const diffInDays = diffInTime / (1000 * 60 * 60 * 24);
  const diffInMonths = diffInDays / 30; // Approximate month calculation

  if (diffInMonths >= 12) {
      return "year(s)";
  } else if (diffInMonths <= 11) {
      return "month(s)";
  } else {
      return "day(s)";
  }
}

export const convertDobToAge = (date, ageUnit) => {
  let currentDate = new Date();
  let dob = new Date(date)

  if (ageUnit == 'year(s)') {
    let year = currentDate.getFullYear() -
      dob.getFullYear()
    if (year == 0) {
      let mnth = currentDate.getMonth() -
        dob.getMonth() + (12 * (currentDate.getFullYear() - dob.getFullYear()))
      if (mnth == 0) {
        const msInDay = 24 * 60 * 60 * 1000;
        let day = Math.round(
          Math.abs(currentDate - dob) / msInDay
        )
        return day + " " + "day(s)"
      }
      return mnth + " " + "month(s)"
    }
    return year + " " + ageUnit
  }


  else if (ageUnit == 'month(s)') {
    let mnth = currentDate.getMonth() -
      dob.getMonth() + (12 * (currentDate.getFullYear() - dob.getFullYear()))
    if (mnth == 0) {
      const msInDay = 24 * 60 * 60 * 1000;
      let day = Math.round(
        Math.abs(currentDate - dob) / msInDay)
      return day + " " + "day(s)"
    }
    else if (mnth > 12) {
      let year = currentDate.getFullYear() -
        dob.getFullYear()
      return year + " " + "year(s)"
    }
    return mnth + " " + ageUnit
  }


  else if (ageUnit == 'day(s)') {
    const msInDay = 24 * 60 * 60 * 1000;
    let day = Math.round(
      Math.abs(currentDate - dob) / msInDay
    )
    if (day > 30) {
      let mnth = currentDate.getMonth() -
        dob.getMonth() + (12 * (currentDate.getFullYear() - dob.getFullYear()))
      return mnth + " " + "month(s)"
    }
    return day + " " + ageUnit
  }
}

// Reads a "YYYY-MM-DD" (or full ISO) dob as local midnight, so a dob that comes
// back from the API as "2025-12-28T00:00:00.000Z" and one that a caller has
// already sliced to "2025-12-28" resolve to the same calendar day.
const parseDob = (value) => {
  if (!value) return null;
  if (typeof value === "string") {
    const [y, m, d] = value.slice(0, 10).split("-").map(Number);
    if (y && m && d) return new Date(y, m - 1, d);
  }
  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? null : parsed;
};

const msInDay = 24 * 60 * 60 * 1000;

// The dob's monthly anniversary n months on, clamped to the length of the target
// month, so 31 Jan + 1 month is 28 Feb rather than spilling into March.
const addMonths = (dob, n) => {
  const month = dob.getMonth() + n;
  const lastDay = new Date(dob.getFullYear(), month + 1, 0).getDate();
  return new Date(dob.getFullYear(), month, Math.min(dob.getDate(), lastDay));
};

// Elapsed years/months/days. Months are counted off the most recent monthly
// anniversary on or before today, so the day count can never come out negative.
const getAgeParts = (date) => {
  const dob = parseDob(date);
  const now = new Date();
  if (!dob || dob > now) return null;

  let totalMonths =
    (now.getFullYear() - dob.getFullYear()) * 12 + (now.getMonth() - dob.getMonth());
  if (addMonths(dob, totalMonths) > now) totalMonths -= 1;

  const anniversary = addMonths(dob, totalMonths);

  return {
    years: Math.floor(totalMonths / 12),
    months: totalMonths % 12,
    days: Math.floor((now - anniversary) / msInDay),
    totalDays: Math.floor((now - dob) / msInDay),
  };
};

// Ages are written whole.sub, never as a decimal fraction: the digits after the
// dot are whole sub-units, so 1y 6m is "1.6" and 5m 15d is "5.15". Read off the
// raw string so "1.1" (1) and "1.10" (10) stay distinct, and clamp the sub-unit
// (11 months, 30 days) so a slip like "1.60" can't run past the next whole unit.
const splitDotParts = (age, maxSub) => {
  const [whole = "", frac = ""] = String(age ?? "").trim().split(".");
  return {
    whole: Math.abs(parseInt(whole, 10)) || 0,
    sub: Math.min(Math.abs(parseInt(frac, 10)) || 0, maxSub),
  };
};

// Local calendar day. toISOString() would report the previous day for anyone
// east of UTC editing before ~06:00, which shifts the dob and the age with it.
const toLocalIsoDate = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate()
  ).padStart(2, "0")}`;

// Display-only age, e.g. "25y 7m" / "7m 3d" / "20d".
export const formatAgeYearMonth = (date) => {
  const parts = getAgeParts(date);
  if (!parts) return "";

  const { years, months, days } = parts;

  if (years >= 1) return months ? `${years}y ${months}m` : `${years}y`;
  if (months >= 1) return days ? `${months}m ${days}d` : `${months}m`;
  return `${days}d`;
};

// Keeps the "<number> <unit(s)>" shape — the age/ageUnit form fields split this
// on the space, so the unit must stay one of year(s)/month(s)/day(s).
export const convertDobToAgeYearMonth = (date) => {
  const parts = getAgeParts(date);
  if (!parts) return "";

  const { years, months, days, totalDays } = parts;

  if (years >= 1) {
    return `${years}.${months} year(s)`;
  } else if (months >= 1) {
    return `${months}.${days} month(s)`;
  } else {
    return `${totalDays} day(s)`;
  }
};


export const convertAgeToDob = (age, ageUnit) => {
  let date = new Date();

  let currentDate = ''
  if (ageUnit == "day(s)") {
    date.setDate(date.getDate() - age);
    currentDate = JSON.stringify(date)
  }

  else if (ageUnit == "month(s)") {
    date.setMonth(date.getMonth() - age);
    currentDate = JSON.stringify(date)
  }
  else if (ageUnit == "year(s)") {
    date.setFullYear(date.getFullYear() - age);
    currentDate = JSON.stringify(date)
  }
  return currentDate?.slice(1, 11)
}

export const convertAgeToDobYearMonth = (age, ageUnit) => {
  let date = new Date();

  if (ageUnit === "year(s)") {
    const { whole: years, sub: months } = splitDotParts(age, 11); // "1.6" → 1y 6m
    date = addMonths(date, -(years * 12 + months));
  }

  else if (ageUnit === "month(s)") {
    const { whole: months, sub: days } = splitDotParts(age, 30); // "5.1" → 5m 1d

    date = addMonths(date, -months);
    if (days > 0) {
      date.setDate(date.getDate() - days);
    }
  }

  else if (ageUnit === "day(s)") {
    date.setDate(date.getDate() - Math.round(age));
  }

  return toLocalIsoDate(date); // yyyy-mm-dd format
};

export const formatDate = (dateString) => {
  // Create a Date object from the input date string
  const date = new Date(dateString);

  // Define the months array
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  // Extract the day, month, and year
  const day = date.getUTCDate();
  const month = months[date.getUTCMonth()];
  const year = date.getUTCFullYear();

  // Format the date in the desired format
  return `${day} ${month}, ${year}`;
}


export function calculateDaysBetween(date) {
  const inputDate = new Date(date);
  const currentDate = new Date();
  const differenceInTime = inputDate - currentDate;
  const differenceInDays = Math.ceil(differenceInTime / (1000 * 60 * 60 * 24));
  return differenceInDays;
}

/** Office location address as a single line (matches API-populated userRole.location). */
export function formatOfficeLocationLine(loc) {
  if (!loc) return "";
  const a = loc.address;
  if (a?.text) return a.text.trim();
  if (a) {
    const parts = [a.lineOne, a.lineTwo, a.city, a.district, a.state, a.country].filter(
      (p) => p && String(p).trim()
    );
    if (parts.length) return parts.join(", ");
  }
  return loc.organization?.name ? String(loc.organization.name).trim() : "";
}

// One medication row as a single printed line: "Napa 500 (1+0+1): after meals".
// The frequency sits in brackets right after the drug, and the note keeps the colon
// Past Medication has always printed with. Any empty part is left out.
export function medicationLineText(medicine) {
  const name = (medicine?.name || "").trim();
  const frequency = (medicine?.frequency || "").trim();
  const note = (medicine?.note || "").trim();

  const head = [name, frequency ? `(${frequency})` : ""].filter(Boolean).join(" ");
  if (!note) return head;
  return head ? `${head}: ${note}` : note;
}

// Resolve which doctor a request should be scoped to.
// Doctor users act as themselves (the userRole's `user`); staff/assistant users
// act on behalf of their currently selected (tagged) doctor.
export function resolveActingDoctorId({ user, selectedRole, selectedDoctor }) {
  const type = user?.user?.type?.toLowerCase();
  if (type === "doctor") return selectedRole?.user || user?.user?._id || "";
  return selectedDoctor?._id || "";
}

// Rheumatologists chart long-standing rheumatic disease rather than working
// hypotheses, so their "Provisional Diagnosis" section is titled
// "Established Chronic Conditions". Matches the userRole's specialty by code
// or display so legacy free-text specialities count too.
export function provisionalDxTitle(role) {
  const isRheumatologist = (role?.specialty || []).some((sp) =>
    `${sp?.code || ""} ${sp?.display || ""}`.toLowerCase().includes("rheumatolog")
  );
  return isRheumatologist ? "Established Chronic Conditions" : "Provisional Diagnosis";
}
